module.exports = __webpack_public_path__ + "static/img/3cbe9304d8d966a0848bc602a9419f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img1.png
// module id = LL6M
// module chunks = 1